export default __webpack_public_path__ + "static/media/icon-doc.6e13266f.svg";